import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const referenceLibraryApi = createApi({
  reducerPath: 'referenceLibraryApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1' }),
  tagTypes: ['ReferenceLibraryItems', 'ReferenceLibraryFolders'],
  endpoints: (builder) => ({
    getReferenceLibraryItems: builder.query({
      query: (searchParams = '') => `/reference_library_items${searchParams}`,
      providesTags: ['ReferenceLibraryItems']
    }),
    getReferenceLibraryFolders: builder.query({
      query: () => '/reference_library_folders',
      providesTags: ['ReferenceLibraryFolders']
    }),
    createReferenceLibraryItem: builder.mutation({
      query: (body) => ({
        url: '/reference_library_items',
        method: 'POST',
        body: { reference_library_item: body }
      }),
      invalidatesTags: ['ReferenceLibraryItems', 'ReferenceLibraryFolders']
    }),
    updateReferenceLibraryItem: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/reference_library_items/${id}`,
        method: 'PATCH',
        body: { reference_library_item: body }
      }),
      invalidatesTags: ['ReferenceLibraryItems', 'ReferenceLibraryFolders']
    }),
    deleteReferenceLibraryItem: builder.mutation({
      query: (id) => ({
        url: `/reference_library_items/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['ReferenceLibraryItems', 'ReferenceLibraryFolders']
    }),
    createReferenceLibraryFolder: builder.mutation({
      query: (body) => ({
        url: '/reference_library_folders',
        method: 'POST',
        body: { reference_library_folder: body }
      }),
      invalidatesTags: ['ReferenceLibraryFolders']
    }),
    updateReferenceLibraryFolder: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/reference_library_folders/${id}`,
        method: 'PATCH',
        body: { reference_library_folder: body }
      }),
      invalidatesTags: ['ReferenceLibraryItems', 'ReferenceLibraryFolders']
    }),
    deleteReferenceLibraryFolder: builder.mutation({
      query: (id) => ({
        url: `/reference_library_folders/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['ReferenceLibraryItems', 'ReferenceLibraryFolders']
    })
  })
})

export const {
  useGetReferenceLibraryItemsQuery,
  useGetReferenceLibraryFoldersQuery,
  useCreateReferenceLibraryItemMutation,
  useUpdateReferenceLibraryItemMutation,
  useDeleteReferenceLibraryItemMutation,
  useCreateReferenceLibraryFolderMutation,
  useUpdateReferenceLibraryFolderMutation,
  useDeleteReferenceLibraryFolderMutation
} = referenceLibraryApi
